var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"handle",staticStyle:{"width":"100%"}},_vm.controlHandlers),[_vm._v(" "+_vm._s(_vm.$_displayValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }